module.exports = __webpack_public_path__ + "img/new-food-burger.0e913d08.png";